export default __webpack_public_path__ + "static/media/josipa-maic.9baab925.jpeg";